import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
  Timestamp
} from "firebase/firestore";

// import {
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
// } from "../../Address";

import { devicePhaseCode, deviceModeCode, serviceType, ticketStates, ticketDeviceTypes } from "../../constants/constants";

import { checkUserAccess, db, getCheckSession, getUserName, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import { createTicket, getAllTickets, updateTicket } from "../../query/ticket.query"
import DeviceDataService from "../../apis/device-data"
import "../../styles/active-tickets.scss";
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import AddIcon from '@material-ui/icons/Add';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, TextField } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from 'uuid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from "@material-ui/core/Menu";
import CreateTickets from "./create-tickets";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const ClosedTickets = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  // const [ctDeviceType, setCtDeviceType] = useState(-1);  
  // const [ctZone, setCtZone] = useState(0);  
  // const [ctWard, setCtWard] = useState(0);  
  // const [ctDeviceID, setCtDeviceID] = useState([]);  
  // const [ctDescription, setCtDescription] = useState([]);  
  // const [ctMobile, setCtMobile] = useState([]);  
  // const [ctAssignee, setCtAssignee] = useState([]);

  const [utAssignee, setUtAssignee] = useState('');
  const [utAssigneeError, setUtAssigneeError] = useState('');
  const [utComment, setUtComment] = useState('');
  const [utCommentError, setUtCommentError] = useState('');

  const [filterObj, setFilterObj] = useState({
    deviceType: -1,
    state: 2,
    zone: 0,
    ward: 0,

  });
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [statusTableFilterList, setStatusTableFilterList] = useState([]);
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);

  const [ticketList, setTicketList] = useState([]);
  const [historyDialog, setHistoryDialog] = useState(null);

  ///Update ticket
  const [updateTicketFlag, setUpdateTicketFlag] = React.useState(null);
  const [updateTicketData, setUpdateTicketData] = React.useState(null);

  const showUpdateTicketDialog = (state, data) => {
    setUtAssignee(data.ass);
    setUpdateTicketData(data);
    setUpdateTicketFlag(state);
  }

  const hideUpdateTicketDialog = () => {
    setUpdateTicketFlag(null);
    setUpdateTicketData(null);
    resetUpdateTicket();
  }

  /// Create Ticket Dialog
  // const [createTicketFlag, setCreateTicketFlag] = React.useState(false);

  const showCreateTicketDialog = () => {
    history.push("/create-tickets");
    // setCreateTicketFlag(true);
  }

  // const hideCreateTicketDialog = () => {
  //   setCreateTicketFlag(false);
  // }

  /// Table Filter
  const [statusTableFilter, setStatusTableFilter] = React.useState(0);


  const handleErrorFilterChange = (event) => {
    setStatusTableFilter(event.target.value);
  };

  useEffect(async () => {
    console.log("========== Active Ticket : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    var reopenTicketStatus = checkUserAccess("reopen_ticket");
    var ticketAccess = checkUserAccess("ticket");

    if (sessionStatus === false || reopenTicketStatus === false || ticketAccess === false) {
      history.push("/");
      return;
    }

    /// Status List
    let statusList = [{ label: "All", value: -1 }];
    for (const statusCode in ticketStates) {
      if (statusCode != 3) {
        statusList.push({
          label: ticketStates[statusCode],
          value: statusCode,
        });
      }
    }
    setStatusTableFilterList(statusList);

    /// Device List 
    let devList = [{ label: "All", value: -1 }];
    for (const devTypeCode in ticketDeviceTypes) {
      devList.push({
        label: ticketDeviceTypes[devTypeCode],
        value: devTypeCode,
      });
    }
    setDeviceTypeList(devList);


    /// Get zone and ward
    await DeviceAddressService.getInstance().getAllAddressAPICall();
    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    setFilterObj((prevState) => ({
      ...prevState,
      deviceType: devList[0].value,
      state: statusList[0].value,
      zone: zoneList[0].value,
      ward: wardList[0].value,
    }));
    await fetchTicket(0, 0, -1, [4]);
  }, []);

  const fetchTicket = async (zone = 0, ward = 0, deviceType = -1, states = [2]) => {
    // debugger;
    var data = await getAllTickets(zone, ward, deviceType, states).catch((e) => {
      console.log(e);
      return;
    });
    console.log("===> rec : ", JSON.stringify(data));
    // debugger;
    setTicketList(data);
  }

  const onClickApplyFilter = async () => {
    // debugger;
    var stateList = [4];
    // if (filterObj.state != -1) {
    //   stateList = [filterObj.state];
    // }
    await fetchTicket(filterObj.zone, filterObj.ward, filterObj.deviceType, stateList);
  }

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    if (name === "deviceType") {
      setFilterObj((prevState) => ({
        ...prevState,
        deviceType: parseInt(value),
      }));
    } else if (name === "state") {
      setFilterObj((prevState) => ({
        ...prevState,
        state: parseInt(value),
      }));
    } else if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: wardList[0].value,
      }));
    } else if (name === "ward") {
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
      }));
    }
  }

  // const onClickCreateTicket = async () => {
  //   const user = await getUserName().catch((error)=> {
  //     console.error(`User name not found. error = ${error}`);
  //   });
  //   var createdDate = Timestamp.fromDate(new Date());
  //   var data = {
  //     id:uuidv4(),
  //     dt:ctDeviceType,
  //     zn:ctZone,
  //     wd:ctWard,
  //     dev_id:ctDeviceID,
  //     desc:ctDescription,
  //     ct:createdDate,
  //     mt:createdDate,
  //     mob:ctMobile,
  //     st:ctAssignee.length > 0 ? 1 : 0,
  //     usr:user,
  //     ass:ctAssignee,
  //     history:[
  //       {
  //         ct:createdDate,
  //         st:ctAssignee.length > 0 ? 1 : 0,
  //         ass:ctAssignee,
  //         com:"",
  //         usr:user,
  //       }
  //     ]
  //   }
  //   await createTicket(data).catch((e)=> {
  //     NotificationManager.error("Failed to create ticket.", "", 3000);
  //     console.log(e)
  //     return;
  //   });
  //   hideCreateTicketDialog();
  //   NotificationManager.success("Ticket created successfully", "", 3000);
  //   resetCreateTicket();
  //   await fetchTicket(0,0,[0,1,3]);
  // }

  // const resetCreateTicket = () => {
  //   setCtDeviceType(-1);
  //   setCtZone(-1);
  //   setCtWard(-1);
  //   setCtDeviceID('');
  //   setCtDescription('');
  //   setCtMobile('');
  //   setCtAssignee('');

  // }

  // Update Ticket
  const onClickUpdateTicket = async () => {
    var error = false;
    const user = await getUserName().catch((error) => {
      console.error(`User name not found. error = ${error}`);
    });

    if (utAssignee == "" || utAssignee.length <= 0) {
      setUtAssigneeError("Enter user name or ID");
      error = true;
    } else {
      setUtAssigneeError("");
    }

    if (utComment == "") {
      setUtCommentError("Enter comment");
      error = true;
    } else if (utComment.length > 500) {
      setUtCommentError("Enter comment less than 500 charectors");
      error = true;
    } else {
      setUtCommentError("");
    }

    if (error) {
      return;
    }
    var modifiedDate = Timestamp.fromDate(new Date());
    var data = {};
    data.id = updateTicketData.id;
    data.st = updateTicketFlag;
    data.ass = utAssignee;
    data.mt = modifiedDate;
    if (updateTicketData.history == undefined || updateTicketData.history == null) {
      updateTicketData.history = [];
    }
    data.history = updateTicketData.history;
    data.history.push({
      ct: modifiedDate,
      st: updateTicketFlag,
      ass: utAssignee,
      com: utComment,
      usr: user,
    });
    // var data = JSON.parse(JSON.stringify(updateTicketData));
    // delete updateTicketData['tableData'];
    await updateTicket(data).catch((e) => {
      NotificationManager.error("Failed to update ticket.", "", 3000);
      console.log(e)
      return;
    });
    hideUpdateTicketDialog();
    NotificationManager.success("Ticket updated successfully", "", 3000);
    resetUpdateTicket();
    onClickApplyFilter();
  }

  const resetUpdateTicket = () => {
    setUtAssignee('');
    setUtAssigneeError('');
    setUtComment('');
    setUtCommentError('');
  }

  /* Contect Menu */
  const [anchorMore, setAnchorMore] = React.useState(null);
  const [actionMenu, setActionMenu] = React.useState(null);

  const handleContextMenuAction = async (event, data) => {
    console.log("row click", data);
    setAnchorMore(event.currentTarget);
    setActionMenu(data ?? null);
  }

  const handleContextMenuClose = async () => {
    setAnchorMore(null);
    setActionMenu(null);
  }

  const [actionFlag, setActionFlag] = useState(false);
  useEffect(() => {
    if (checkUserAccess("reopen_ticket")) {
      setActionFlag(true)
    }
  }, [])

  const getColumnList = () => {
    return [
      {
        title: 'DATE',
        field: "ct",
        sorting: true,
        type: "datetime",
        render: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
        exportTransformer: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
      },
      {
        title: 'DURATION ',
        field: "mt",
        type: "datetime",
        sorting: true,
        render: ({ mt: mt = '', ct: ct = '' }) => {

          var modified = mt.toDate();
          var created = ct.toDate();
          var difference = (modified - created) / 3600000
          console.log(difference)
          if (difference < 24) {
            return "🟡"
          }
          else if (difference < 48) {
            return "🔵"
          }
          else {
            return "🔴";
          }

        },
        exportTransformer: ({ mt: mt = '', ct: ct = '' }) => {

          var modified = mt.toDate();
          var created = ct.toDate();
          var difference = (modified - created) / 3600000

          if (difference < 24) {
            return "24 Hours"
          }
          else if (difference < 48) {
            return "48 Hours"
          }
          else {
            return "More than 48 hours";
          }
        },
      },
      {
        title: 'TICKET ID',
        field: "id",
        sorting: true,
        render: ({ id: id = "" }) => {
          return id;
        },
        exportTransformer: ({ id: id = "" }) => {
          return id;
        },
      },
      {
        title: 'DEVICE TYPE',
        field: "dt",
        sorting: true,
        render: ({ dt: dt = -1 }) => {
          if (dt == -1) {
            return "";
          }
          return ticketDeviceTypes[dt];
        },
        exportTransformer: ({ dt: dt = -1 }) => {
          if (dt == -1) {
            return "";
          }
          return ticketDeviceTypes[dt];
        },
      },
      {
        title: 'ZONE',
        field: "zn",
        sorting: true,
        render: ({ zn: zn = '' }) => {
          return zn;
        },
        exportTransformer: ({ zn: zn = '' }) => {
          return zn;
        },
      },
      {
        title: 'WARD',
        field: "wd",
        sorting: true,
        render: ({ wd: wd = '' }) => {
          return wd;
        },
        exportTransformer: ({ wd: wd = '' }) => {
          return wd;
        },
      },
      {
        title: 'STREET',
        field: "strt",
        sorting: true,
        render: ({ strt: strt = '' }) => {
          return strt;
        },
        exportTransformer: ({ strt: strt = '' }) => {
          return strt;
        },
      },
      {
        title: 'DEVICE ID',
        field: "dev_id",
        sorting: true,
        render: ({ dev_id: dev_id = 'NA' }) => {
          return dev_id;
        },
        exportTransformer: ({ dev_id: dev_id = 'NA' }) => {
          return dev_id;
        },
      },
      {
        title: 'COMPLAINT',
        sorting: false,
        render: ({ desc: desc = '' }) => {
          return desc;
        },
        exportTransformer: ({ desc: desc = '' }) => {
          return desc;
        },
      },
 {
        title: 'STATUS',
        sorting: false,
        render: ({ st: st = 0, mt = 0, com_dt }) => {
          const date = com_dt ?? mt;
          if (st === 1) {
            return ticketStates[st];
          }
          return `${ticketStates[st]}\n[${format(date.toDate(), "dd/MM/yyyy, hh:mm a")}]`;
        },
        exportTransformer: ({ st: st = 0, mt = 0, com_dt }) => {
          const date = com_dt ?? mt;
          if (st === 1) {
            return ticketStates[st];
          }
          return `${ticketStates[st]}\n[${format(date.toDate(), "dd/MM/yyyy, hh:mm a")}]`;
        },
      },
      {
        title: 'ASSIGNED TO',
        field: "ass",
        sorting: true,
        render: ({ ass: ass = "", assMob: assMob = "" }) => {
          return `${ass} - ${assMob}`;
        },
        exportTransformer: ({ ass: ass = "", assMob: assMob = "" }) => {
          return `${ass} - ${assMob}`;
        },
      },
      {
        title: 'COMPLAINANT BY',
        // field: "dev_md",
        sorting: false,
        render: ({ comNam: comNam = "", comMob: comMob = "" }) => {
          return `${comNam} - ${comMob}`;
        },
        exportTransformer: ({ comNam: comNam = "", comMob: comMob = "" }) => {
          return `${comNam} - ${comMob}`;
        },
      },
      {
        title: 'CREATED BY',
        // field: "on_time",
        sorting: false,
        render: ({ usr: usr = "" }) => {
          return usr;
        },
        exportTransformer: ({ usr: usr = "" }) => {
          return usr;
        },
      },
      {
        title: "ACTION",
        sorting: false,
        export: false,
        render: (data) => {
          return (<div>
            <IconButton aria-label="more" aria-controls="long-menu"
              aria-haspopup="true" onClick={(event) => { handleContextMenuAction(event, data) }}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorMore}
              keepMounted
              open={(actionMenu != null && actionMenu == data) ? true : false}
              onClose={handleContextMenuClose}
            >
              <MenuItem key={"Show History"} onClick={() => { showHistoryDialog(data); }}>{"Show History"}</MenuItem>
              {(data.st == 4) && actionFlag ?
                <MenuItem key={"Reopen Ticket"} onClick={() => { showUpdateTicketDialog(3, data); }}>{"Reopen Ticket"}</MenuItem> : <></>}
            </Menu>
          </div>);
        },
      }
    ];
  };

  const showHistoryDialog = (data) => {
    if (data.history != undefined) {
      setHistoryDialog(data);
    }
    handleContextMenuClose();
  }

  const hideHistoryDialog = () => {
    setHistoryDialog(null);
  }

  const getHistoryColumnList = () => {
    return [
      {
        title: 'DATE',
        // field: "date",
        type: "datetime",
        render: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
        exportTransformer: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
      },
      {
        title: 'STATUS',
        // field: "ctr_ty",
        render: ({ st: st = 0 }) => {
          return ticketStates[st];
        },
        exportTransformer: ({ st: st = 0 }) => {
          return ticketStates[st];
        },
      },
      {
        title: 'ASSIGNED TO',
        // field: "on_time",
        render: ({ ass: ass = "" }) => {
          return ass;
        },
        exportTransformer: ({ ass: ass = "" }) => {
          return ass;
        },
      },
      {
        title: 'COMMENT',
        render: ({ com: com = '' }) => {
          return com;
        },
        exportTransformer: ({ com: com = '' }) => {
          return com;
        },
      }
    ];
  };

  const {
    deviceType: deviceTypeFilter = -1,
    state: stateFilter = -1,
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
  } = filterObj;

  return (
    <div className="root-container reports">
      <h2 className="reports-header">Closed Tickets</h2>

      <Grid container className="reports-filter-wrapper">
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
            {/* <Grid item> */}
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="zone-filter-label">Zone</InputLabel>
              <Select
                // style={{width:250}}
                labelId="zone-filter-label"
                id="zoneFilter"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* </Grid> */}
            {/* Zone */}
            {/* <Grid item> */}
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="ward-filter-label">Ward</InputLabel>
              <Select
                // style={{width:250}}
                labelId="ward-filter-label"
                id="wardFilter"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* </Grid> */}
            {/* Device State */}
            {/* <Grid item>
        <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          <InputLabel id="state-table-filter">State</InputLabel>
        <Select
          style={{width:250}}
            labelId="state-table-filter"
            id="state-table-filter"
            name="state"
            value={stateFilter}
            onChange={handleFilterChange}
          >
            {statusTableFilterList.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          </FormControl>
        </Grid> */}
            {/* Device Type */}
            {/* <Grid item> */}
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="device-filter-label">Device</InputLabel>
              <Select
                // style={{width:250}}
                labelId="device-filter-label"
                id="deviceFilter"
                name="deviceType"
                value={deviceTypeFilter}
                onChange={handleFilterChange}
                label="device"
              >
                {deviceTypeList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* </Grid> */}
            {/* Apply Filter */}
            {/* <Grid item> */}
            <Button variant="contained"
              className="ml-auto reports-apply-btn" color="primary" onClick={onClickApplyFilter}>
              Apply
            </Button>
            {/* </Grid> */}
            {/* Create Ticket */}
            {/* <Grid item>
          <Button color="primary" onClick={showCreateTicketDialog}  variant="contained" style={{marginLeft:20, marginTop:10}}>
            Create Ticket
          </Button>
        </Grid> */}
          </div>
        </Grid>
      </Grid>

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getColumnList()}
          data={ticketList}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          // components={{
          //   // Container: props => props.children,
          //   // Actions: ({ data }) => <button>hello world</button>,
          //   Actions: ({ data }) => {
          //       return (
          //         <Grid container>
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //               <InputLabel id="zone-filter-label">Zone</InputLabel>
          //               <Select
          //               style={{width:250}}
          //                 labelId="zone-filter-label"
          //                 id="zoneFilter"
          //                 name="zone"
          //                 value={zoneFilter}
          //                 onChange={handleFilterChange}
          //                 label="Zone"
          //               >
          //                 {zoneFilterList.map((item) => (
          //                   <MenuItem key={item.value} value={item.value}>
          //                     {item.label}
          //                   </MenuItem>
          //                 ))}
          //               </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Zone */}
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="ward-filter-label">Ward</InputLabel>
          //             <Select
          //             style={{width:250}}
          //               labelId="ward-filter-label"
          //               id="wardFilter"
          //               name="ward"
          //               value={wardFilter}
          //               onChange={handleFilterChange}
          //               label="Ward"
          //             >
          //               {wardFilterList.map((item) => (
          //                 <MenuItem value={item.value}>{item.label}</MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Device State */}
          //           {/* <Grid item>
          //           <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="state-table-filter">State</InputLabel>
          //           <Select
          //             style={{width:250}}
          //               labelId="state-table-filter"
          //               id="state-table-filter"
          //               name="state"
          //               value={stateFilter}
          //               onChange={handleFilterChange}
          //             >
          //               {statusTableFilterList.map((item) => (
          //                 <MenuItem key={item.value} value={item.value}>
          //                   {item.label}
          //                 </MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid> */}
          //           {/* Device Type */}
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="device-filter-label">Device</InputLabel>
          //             <Select
          //             style={{width:250}}
          //               labelId="device-filter-label"
          //               id="deviceFilter"
          //               name="deviceType"
          //               value={deviceTypeFilter}
          //               onChange={handleFilterChange}
          //               label="device"
          //             >
          //               {deviceTypeList.map((item) => (
          //                 <MenuItem value={item.value}>{item.label}</MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Apply Filter */}
          //           <Grid item>
          //             <Button color="primary" onClick={onClickApplyFilter}  variant="contained" style={{marginLeft:10, marginTop:10}}>
          //               Filter
          //             </Button>
          //           </Grid>
          //           {/* Create Ticket */}
          //           {/* <Grid item>
          //             <Button color="primary" onClick={showCreateTicketDialog}  variant="contained" style={{marginLeft:20, marginTop:10}}>
          //               Create Ticket
          //             </Button>
          //           </Grid> */}
          //         </Grid>
          //       )
          //   }
          // }}
          options={{
            exportButton: true,
            exportAllData: true,
            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Closed_Tickets-${getDateString()}`); },
            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Closed_Tickets-${getDateString()}`, 8, 18); },
            // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
      {/* Create ticket dialog */}
      {/* <Dialog className="create-ticket-dialog" open={createTicketFlag} onClose={hideCreateTicketDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        {/* <DialogTitle id="form-dialog-title">Create Ticket</DialogTitle> * /}
        <DialogContent>
          <CreateTickets />
          {/* <DialogContentText>
            To subscribe to this website, please enter your email address here. We will send updates
            occasionally.
          </DialogContentText> */}
      {/* <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
            {/* Device Type * /}
            <InputLabel id="device-type-label">Device Type</InputLabel>
            <Select
              required
              labelId="device-type-label"
              id="device-type-label"
              name="deviceType"
              value={ctDeviceType}
              onChange={handleFilterChange}
              label="Device Type"
              
            >
              {/* <MenuItem value={"all"}>All</MenuItem> * /}
              {deviceTypeList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
            {/* Zone * /}
            <InputLabel id="zone-label">Zone</InputLabel>
            <Select
              labelId="zone-label"
              id="zone"
              name="zone"
              value={ctZone}
              onChange={handleFilterChange}
              label="Zone"
            >
              {zoneFilterList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
            {/* Ward * /}
            <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward"
                name="ward"
                value={ctWard}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="dialog-form" style={{width:'100%', margin:'0px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="deviceId"
                label="Device ID"
                type="text"
                value={ctDeviceID}
                onChange={(e)=> {
                  setCtDeviceID(e.target.value);
                }}
              />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">Complaint</label>
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0px 0px 0px'}}>
            <TextareaAutosize
            labelId="complaint-label"
            label="Complaint"
            minRows={5}
            maxRows={5}
            aria-label="Complaint"
            placeholder="Maximum 500 charectors"
            value={ctDescription}
            onChange={(e)=> {
              setCtDescription(e.target.value);
            }}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'0px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="mobile"
                label="Mobile"
                type="text"
                value={ctMobile}
                onChange={(e)=> {
                  setCtMobile(e.target.value);
                }}
              />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="assignee"
                label="Assigned to"
                type="text"
                value={ctAssignee}
                onChange={(e)=> {
                  setCtAssignee(e.target.value);
                }}
              />
          </FormControl> * /}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={hideCreateTicketDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={onClickCreateTicket} color="primary">
            Create
          </Button>
        </DialogActions> * /}
      </Dialog> */}

      {/* Update State dialog */}
      <Dialog className="update-ticket-dialog" open={updateTicketFlag != null} onClose={hideUpdateTicketDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        <DialogTitle id="form-dialog-title">Update State</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            To subscribe to this website, please enter your email address here. We will send updates
            occasionally.
          </DialogContentText> */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              autoFocus
              margin="dense"
              id="status"
              label="Status"
              type="text"
              value={ticketStates[updateTicketFlag]}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }}>
            <TextField
              error={utAssigneeError.length > 0 ? true : false}
              helperText={utAssigneeError}
              autoFocus
              margin="dense"
              id="assignee"
              label="Assigned to"
              type="text"
              value={utAssignee}
              onChange={(e) => {
                setUtAssignee(e.target.value);
              }}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }}>
            <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">COMMENT</label>
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0px 0px 0px' }}>
            <TextareaAutosize
              labelId="comment-label"
              label="Comment"
              minRows={5}
              maxRows={5}
              aria-label="Comment"
              placeholder="Maximum 500 charectors"
              value={utComment}
              onChange={(e) => {
                setUtComment(e.target.value);
              }}
            />
            <FormHelperText className="Mui-error">{utCommentError}</FormHelperText>
          </FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={hideUpdateTicketDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={onClickUpdateTicket} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* History Dialog */}
      <Dialog className="history-dialog" open={historyDialog != null} onClose={hideHistoryDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        <DialogTitle id="form-dialog-title">Ticket History </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {historyDialog?.desc}
          </DialogContentText>
          <MaterialTable
            style={{
              margin: "20px 0",
              width: "100%",
            }}
            className={classes.table}
            title={`ID: ${historyDialog?.id}`}
            columns={getHistoryColumnList()}
            data={historyDialog?.history ?? []}
            // onRowClick={(evt, rowData) => {
            //   console.log("row click", evt, rowData);
            //   // setSelectedRowData(rowData);
            //   // setIsErrorDialogOpen(true);
            // }}

            options={{
              exportButton: false,
              // exportAllData:true,
              // exportCsv:(columns, csvData) => {exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`);},
              // exportPdf:(columns, csvData) => {exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18);},
              // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
              // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
              // grouping: true,
              search: false,
              selection: false,
              sorting: false,
              pageSize: 5,
              // rowStyle: (rowData) => ({
              //   backgroundColor:
              //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
              //       ? "#f0f2f4"
              //       : "",
              // }),
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              toolbar: {
                searchPlaceholder: "Search",
                exportCSVName: "Export as Excel",
                exportPDFName: "Export as PDF",
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={hideHistoryDialog} color="primary">
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ClosedTickets;
